<script>
  // import Fa from "svelte-fa";
  import img_datadocs_logo_home from "./icon-imgs/datadocs_logo_home.svg";
  import img_datadocs_logo_home_light from "./icon-imgs/datadocs_logo_home_light.svg";
  import img_datadocs_logo from "./icon-imgs/datadocs_logo.svg";
  import img_input_email from "./icon-imgs/form/input_email.svg";
  import img_input_password from "./icon-imgs/form/input_password.svg";
  import img_input_password_invisible from "./icon-imgs/form/input_password_invisible.svg";
  import img_input_password_visible from "./icon-imgs/form/input_password_visible.svg";
  import img_waitlist_send from "./icon-imgs/waitlist/waitlist_send.svg";
  import img_loading from "./icon-imgs/loading.svg";
  import img_more_info from "./icon-imgs/more_info.svg";
  import img_success_indicator from "./icon-imgs/success_indicator.svg";
  import img_splash_excel from "./icon-imgs/splash/splash_excel.svg";
  import img_splash_analysis from "./icon-imgs/splash/splash_analysis.svg";
  import img_splash_dashboard from "./icon-imgs/splash/splash_dashboard.svg";
  import img_splide_arrow_left from "./icon-imgs/splash/splide_arrow_left.svg";
  import img_splide_arrow_right from "./icon-imgs/splash/splide_arrow_right.svg";
  import img_splide_close_notification from "./icon-imgs/splash/splide_close_notification.svg";
  import img_facebook from "./icon-imgs/footer/facebook.svg";
  import img_twitter from "./icon-imgs/footer/twitter.svg";
  import img_pinterest from "./icon-imgs/footer/pinterest.svg";
  import img_google from "./icon-imgs/google_logo.svg";
  import img_input_error_indicator from "./icon-imgs/form/input_error_indicator.svg";
  import img_login_message_lock from "./icon-imgs/login_message_lock.svg";
  import img_copy from "./icon-imgs/copy.svg";
  import img_email_notification from "./icon-imgs/email_notification.svg";
  import img_blockquote_icon from "./icon-imgs/blockquote_icon.svg";
  import img_breadcrumb from "./icon-imgs/breadcrumb.svg";
  import img_question_mark from "./icon-imgs/question_mark.svg";
  import img_individual from "./icon-imgs/individual.svg";
  import img_organization from "./icon-imgs/organization.svg";
  import img_blue_tick from "./icon-imgs/blue_tick.svg";
  import img_red_cross from "./icon-imgs/red_cross.svg";
  import img_plan_standard from "./icon-imgs/plan_standard.svg";
  import img_plan_business from "./icon-imgs/plan_business.svg";
  import img_plan_professional from "./icon-imgs/plan_professional.svg";
  import img_arrow_down from "./icon-imgs/arrow_down.svg";
  import img_credit_card from "./icon-imgs/credit_card.svg";
  import img_paypal from "./icon-imgs/paypal.svg";
  import img_master_card_logo from "./icon-imgs/master_card_logo.svg";
  import img_date_icon from "./icon-imgs/date_icon.svg";
  import img_payment_lock from "./icon-imgs/payment_lock.svg";
  import img_circle_tick from "./icon-imgs/circle_tick.svg";

  // payment card logo
  import img_paymentcard_amex from "./icon-imgs/card-payment/amex.svg";
  import img_paymentcard_diners from "./icon-imgs/card-payment/diners.svg";
  import img_paymentcard_discover from "./icon-imgs/card-payment/discover.svg";
  import img_paymentcard_jcb from "./icon-imgs/card-payment/jcb.svg";
  import img_paymentcard_mastercard from "./icon-imgs/card-payment/mastercard.svg";
  import img_paymentcard_unionpay from "./icon-imgs/card-payment/unionpay.svg";
  import img_paymentcard_visa from "./icon-imgs/card-payment/visa.svg";

  export let icon = "";
  export let data = "";

  export let size = "12px";
  export let width = size;
  export let height = size;
  export let color = "currentColor";
  export let stroke = "transparent";
  export let fill = color;

  let className = "";
  export { className as class };

  export let svg = null;

  let viewBox = "";

  function extractViewBox(svg) {
    const regex = /viewBox="([\d\- \.]+)"/;
    const res = regex.exec(svg);
    if (!res) return `0 0 12 12`; // default value
    return res[1];
  }

  $: {
    switch (icon) {
      case "datadocs-logo": {
        data = img_datadocs_logo;
        break;
      }
      case "datadocs-logo-home": {
        data = img_datadocs_logo_home;
        break;
      }
      case "datadocs-logo-home-light": {
        data = img_datadocs_logo_home_light;
        break;
      }
      case "input-email": {
        data = img_input_email;
        break;
      }
      case "input-password": {
        data = img_input_password;
        break;
      }
      case "password-invisible": {
        data = img_input_password_invisible;
        break;
      }
      case "password-visible": {
        data = img_input_password_visible;
        break;
      }
      case "waitlist-send": {
        data = img_waitlist_send;
        break;
      }
      case "more-info": {
        data = img_more_info;
        break;
      }
      case "success-indicator": {
        data = img_success_indicator;
        break;
      }
      case "loading": {
        data = img_loading;
        break;
      }
      case "splash-excel": {
        data = img_splash_excel;
        break;
      }
      case "splash-analysis": {
        data = img_splash_analysis;
        break;
      }
      case "splash-dashboard": {
        data = img_splash_dashboard;
        break;
      }
      case "splide-arrow-left": {
        data = img_splide_arrow_left;
        break;
      }
      case "splide-arrow-right": {
        data = img_splide_arrow_right;
        break;
      }
      case "splide-close-notification": {
        data = img_splide_close_notification;
        break;
      }
      case "facebook": {
        data = img_facebook;
        break;
      }
      case "twitter": {
        data = img_twitter;
        break;
      }
      case "pinterest": {
        data = img_pinterest;
        break;
      }
      case "google": {
        data = img_google;
        break;
      }
      case "input-error-indicator": {
        data = img_input_error_indicator;
        break;
      }
      case "login-message-lock": {
        data = img_login_message_lock;
        break;
      }
      case "copy": {
        data = img_copy;
        break;
      }
      case "email-notification": {
        data = img_email_notification;
        break;
      }
      case "blockquote-icon": {
        data = img_blockquote_icon;
        break;
      }
      case "breadcrumb": {
        data = img_breadcrumb;
        break;
      }
      case "question-mark": {
        data = img_question_mark;
        break;
      }
      case "individual": {
        data = img_individual;
        break;
      }
      case "organization": {
        data = img_organization;
        break;
      }
      case "blue-tick": {
        data = img_blue_tick;
        break;
      }
      case "red-cross": {
        data = img_red_cross;
        break;
      }
      case "plan-standard": {
        data = img_plan_standard;
        break;
      }
      case "plan-business": {
        data = img_plan_business;
        break;
      }
      case "plan-professional": {
        data = img_plan_professional;
        break;
      }
      case "arrow-down": {
        data = img_arrow_down;
        break;
      }
      case "credit-card": {
        data = img_credit_card;
        break;
      }
      case "paypal": {
        data = img_paypal;
        break;
      }
      case "master-card-logo": {
        data = img_master_card_logo;
        break;
      }
      case "date-icon": {
        data = img_date_icon;
        break;
      }
      case "payment-lock": {
        data = img_payment_lock;
        break;
      }
      case "circle-tick": {
        data = img_circle_tick;
        break;
      }
      case "paymentcard-amex": {
        data = img_paymentcard_amex;
        break;
      }
      case "paymentcard-diners": {
        data = img_paymentcard_diners;
        break;
      }
      case "paymentcard-discover": {
        data = img_paymentcard_discover;
        break;
      }
      case "paymentcard-jcb": {
        data = img_paymentcard_jcb;
        break;
      }
      case "paymentcard-mastercard": {
        data = img_paymentcard_mastercard;
        break;
      }
      case "paymentcard-unionpay": {
        data = img_paymentcard_unionpay;
        break;
      }
      case "paymentcard-visa": {
        data = img_paymentcard_visa;
        break;
      }
      default:
        break;
    }

    viewBox = extractViewBox(data);
  }

  $: elements = data.replace(/<svg ([^>]*)>/, "").replace("</svg>", "");

  $: firstLetter = icon.charAt(0);
</script>

{#if data !== ""}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    bind:this={svg}
    {width}
    {height}
    {viewBox}
    {stroke}
    {fill}
    {...$$restProps}
    class={className}
    on:click
  >
    {@html elements}
  </svg>
  <!-- {:else if firstLetter !== undefined}
  <Fa icon={faBorderStyle} size="lg" class="inline-block" color={fill}/> -->
{/if}
